import Cookies from 'js-cookie';
import FetchData from '../Components/ServerCall/FetchData';

/**
 
 * **/
export interface IWorkspaceTree {
  workspaceId: string;
  workspaceName: string;
  subWorkspaces: ISubworksapceTree[];
}
export interface ISubworksapceTree {
  workspaceId: string;
  workspaceName: string;
}
export const getAllSubworkspace = async () => {
  const res = await FetchData({
    requestType: 'noData',
    method: 'GET',
    url: `workspaces/tree`,
    headers: { Authorization: `Bearer ${Cookies.get('authToken')}` },
  });

  if (!res.status)
    return {
      isError: true,
      message: (res.error ?? 'Error while fetching data') as string,
      data: null,
    };

  return {
    isError: false,
    message: 'Tree fetched successfully',
    data: res.data as IWorkspaceTree[],
  };
};
/**
 *
 * @param worksapceId
 * @param newWorkspaceName
 * @param parentWorkspaceId if its a subworkspace
 */
export async function updateWorkspace(
  worksapceId: string,
  newWorkspaceName: string,
  parentWorkspaceId?: string,
) {
  const res = await FetchData({
    requestType: 'withData',
    method: 'PUT',
    url: parentWorkspaceId ? 'sub-workspace/update' : 'workspace/update',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${Cookies.get('authToken')}`,
    },
    data: {
      workspaceId: worksapceId,
      name: newWorkspaceName,
      parentId: parentWorkspaceId,
    },
  });
  if (!res.status) {
    console.log('Error in updating workspace', res.data);
    return {
      isError: true,
      message: (res.error ?? `Failed to update ${newWorkspaceName}`) as string,
      data: null,
    };
  }
  return {
    isError: false,
    message: 'Workspace updated successfully',
    data: res.data as string,
  };
}
/**
 *
 * @param newWorkspaceName
 * @param parentWorkspaceId if its a subworkspace
 */
export async function createWorkspace(workspaceName: string, parentWorkspaceId?: string) {
  const res = await FetchData({
    requestType: 'withData',
    method: 'POST',
    url: parentWorkspaceId ? 'sub-workspace/create' : 'workspace/create',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${Cookies.get('authToken')}`,
    },
    data: {
      name: workspaceName,
      parentId: parentWorkspaceId,
    },
  });
  if (!res.status) {
    return {
      isError: true,
      message: (res.error ?? `Failed to create ${workspaceName}`) as string,
      data: null,
    };
  }
  return {
    isError: false,
    message: 'Workspace created successfully',
    data: res.data as { id: String; name: string; parentId: string | null },
  };
}
/**
 *
 * @param workspaceId
 * @param isSubworkspace if its a subworkspace
 */
export async function deleteWorkspace(workspaceId: string, isSubworkspace = false) {
  const res = await FetchData({
    requestType: 'noData',
    method: 'DELETE',
    url: isSubworkspace ? `sub-workspace/delete/${workspaceId}` : `workspace/${workspaceId}`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${Cookies.get('authToken')}`,
    },
  });
  if (!res.status) {
    console.log('Error in deleting workspace', res.data);
    return {
      isError: true,
      /**For error this res.data is string after observing the api response */
      message: (res.error ?? 'Cannot perform delete operation') as string,
      data: null,
    };
  }
  return {
    isError: false,
    message: 'Workspace deleted successfully',
    data: 'Workspace deleted successfully',
  };
}
/**
 * @param contentId
 * @pram newName
 * @param parentWorkspaceId
 * @param contentType
 */
export async function renameContent(
  contentId: string,
  newName: string,
  parentWorkspaceId: string,
  contentType: number,
) {
  const res = await FetchData({
    requestType: 'withData',
    method: 'PUT',
    url: 'content/rename',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${Cookies.get('authToken')}`,
    },
    data: {
      contentId,
      name: newName,
      workspaceId: parentWorkspaceId,
      contentTypeId: contentType,
    },
  });
  if (!res.status) {
    console.log('Error in renaming content', res.data);
    return {
      isError: true,
      message: (res.error ?? `Unable to rename it to ${newName}`) as string,
      data: null,
    };
  }
  return {
    isError: false,
    message: 'Content renamed successfully',
    data: `Successfully renamed to ${newName}`,
  };
}

export async function getContentDependencies(
  contentId: string,
  contentType: string,
  workspaceId: string,
) {
  const res = await FetchData({
    url: `content/dependency/${contentId}?workspaceId=${workspaceId}&contentType=${contentType}`,
    method: 'GET',
    requestType: 'noData',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${Cookies.get('authToken')}`,
    },
  });
  if (res.status) {
    return {
      hasDependency: res.data.length > 0,
      dependencies: res.data,
      dependencyType: '',
      error: null,
    };
  } else {
    return {
      hasDependency: false,
      dependencies: [],
      dependencyType: '',
      error: res.error ?? 'Unable to fetch Dependency',
    };
  }
}

export async function deleteContent(contentId: string, worksapceId: string, contentType: number) {
  const response = await FetchData({
    requestType: 'noData',
    method: 'DELETE',
    url: `content/delete/${contentId}?workspaceId=${worksapceId}&contentType=${contentType}`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${Cookies.get('authToken')}`,
    },
  });
  if (!response.status) {
    console.log('Error in deleting content', response.data);
    return {
      isError: true,
      message: (response.error ?? 'Cannot perform delete operation') as string,
      data: null,
    };
  }
  return {
    isError: false,
    message: 'Content deleted successfully',
    // data: response.data as string,
    data: 'Content deleted successfully',
  };
}
export async function getPrivilege(workspaceId: string, contentType: number, contentId: string) {
  if (!workspaceId || !contentType || !contentId)
    return {
      isError: true,
      message: 'Invalid parameters',
      data: null,
    };
  try {
    const res = await FetchData({
      requestType: 'noData',
      method: 'GET',
      url: `privilege?workspaceId=${workspaceId}&contentTypeId=${contentType}&contentId=${contentId}`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${Cookies.get('authToken')}`,
      },
    });
    if (res.status) {
      return {
        isError: false,
        message: 'Privilege fetched successfully',
        data: res.data as { levelId: number },
      };
    } else {
      return {
        isError: true,
        message: (res.error ?? 'Invalid response') as string,
        data: null,
      };
    }
  } catch (error) {
    return {
      isError: true,
      message: (error as Error).message,
      data: null,
    };
  }
}

export async function getWorkspaceUserAccess(
  workspaceId: string,
  payload: {
    granteeId: string;
    isGroup: boolean;
    roleId: number;
    customPermissions?: {
      contentTypeId: number;
      privilegeId: number;
    }[];
  },
) {
  const response = await FetchData({
    requestType: 'withData',
    method: 'POST',
    url: `workspace/access/${workspaceId}`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${Cookies.get('authToken')}`,
    },
    data: payload,
  });

  if (!response.status) {
    return {
      isError: true,
      message: (response.error ?? 'Error while fetching Workspace user access') as string,
      data: null,
    };
  }
  return {
    isError: false,
    message: 'Workspace user access fetched successfully',
    data: response.data as string,
  };
}
